// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quick-client .quick-hint {
  margin: 0 0 14px;
  font-size: 0.85rem;
  color: #64748b;
}
.quick-client .quick-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
.quick-client .quick-grid label {
  display: block;
  margin-bottom: 6px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #475569;
}
.quick-client .quick-grid input {
  width: 100%;
}
.quick-client .quick-grid small {
  display: block;
  margin-top: 4px;
}
.quick-client .quick-actions {
  margin-top: 16px;
}
@media (max-width: 560px) {
  .quick-client .quick-grid {
    grid-template-columns: 1fr;
  }
}
.quick-client .quick-grid.more {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid #eef0f3;
}
.quick-client .quick-grid.more .wide {
  grid-column: 1 / -1;
}
/*# sourceMappingURL=clients-form-detail.component.css.map */`, "",{"version":3,"sources":["webpack://./clients-form-detail.component.less","webpack://./src/app/components/clients-form-detail/clients-form-detail.component.less"],"names":[],"mappings":"AAAA;EAEI,gBAAA;EACA,kBAAA;EACA,cAAA;ACAJ;ADJA;EAQI,aAAA;EACA,8BAAA;EACA,SAAA;ACDJ;ADTA;EAaM,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;ACDN;ADhBA;EAqBM,WAAA;ACFN;ADnBA;EAyBM,cAAA;EACA,eAAA;ACHN;ADvBA;EA+BI,gBAAA;ACLJ;ADSA;EACE;IACE,0BAAA;ECPF;AACF;ADUA;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;ACRF;ADKA;EAMI,mBAAA;ACRJ;AACA,4DAA4D","sourcesContent":[".quick-client {\n  .quick-hint {\n    margin: 0 0 14px;\n    font-size: 0.85rem;\n    color: #64748b;\n  }\n\n  .quick-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 14px;\n\n    label {\n      display: block;\n      margin-bottom: 6px;\n      font-size: 0.8rem;\n      font-weight: 600;\n      color: #475569;\n    }\n\n    input {\n      width: 100%;\n    }\n\n    small {\n      display: block;\n      margin-top: 4px;\n    }\n  }\n\n  .quick-actions {\n    margin-top: 16px;\n  }\n}\n\n@media (max-width: 560px) {\n  .quick-client .quick-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.quick-client .quick-grid.more {\n  margin-top: 14px;\n  padding-top: 14px;\n  border-top: 1px solid #eef0f3;\n\n  .wide {\n    grid-column: 1 / -1;\n  }\n}\n",".quick-client .quick-hint {\n  margin: 0 0 14px;\n  font-size: 0.85rem;\n  color: #64748b;\n}\n.quick-client .quick-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n.quick-client .quick-grid label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #475569;\n}\n.quick-client .quick-grid input {\n  width: 100%;\n}\n.quick-client .quick-grid small {\n  display: block;\n  margin-top: 4px;\n}\n.quick-client .quick-actions {\n  margin-top: 16px;\n}\n@media (max-width: 560px) {\n  .quick-client .quick-grid {\n    grid-template-columns: 1fr;\n  }\n}\n.quick-client .quick-grid.more {\n  margin-top: 14px;\n  padding-top: 14px;\n  border-top: 1px solid #eef0f3;\n}\n.quick-client .quick-grid.more .wide {\n  grid-column: 1 / -1;\n}\n/*# sourceMappingURL=clients-form-detail.component.css.map */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
